
export const DarkModeTrue = () => {
    return {
        type: "TOGGLE_TRUE"
    }
}
export const DarkModeFalse = () => {
    return {
        type: "TOGGLE_FALSE"
    }
}